<ap-button
    [ngClass]="{ 'ap-display-inline-block': !environment.mobile }"
    class="ap-margin-top-4 ap-margin-bottom-1"
    id="nextButton"
    type="submit"
    [wide]="environment.mobile"
>
    <ap-submit-text
        [isLoading]="isLoading"
        [loadingText]="'general.question.loading' | apContent"
        [submitText]="contentKey | apContent"
    ></ap-submit-text>
</ap-button>
